import { Route, useHistory } from 'react-router-dom'
import CookiesStorageService from './CookiesStorageService'
import { isNotEmpty } from '../utils/helpers'
import AppRoutes from './AppRoutes'
import ResponsiveAppBar from '../components/ResponsiveAppBar'

const AllRollsPublicAuthRoute = ({ component: Component, path, ...props }) => {
  const history = useHistory()
  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''

  if (isNotEmpty(CookiesStorageService.getAccessToken())) {
    return <Route exact path={path} component={
      () => (
        <>
          <ResponsiveAppBar adminType={CookiesStorageService.getAdminType()} />
          <Component/>
        </ >)
    } {...props} />
  }

  return history.push(baseUri + AppRoutes.home)
}

export default AllRollsPublicAuthRoute
